import React, { useId } from 'react';
import { ChevronDown } from 'lucide-react';
interface Option {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: Option[];
  error?: string;
  fullWidth?: boolean;
}
export function Select({
  label,
  options,
  error,
  className = '',
  fullWidth = true,
  id,
  ...props
}: SelectProps) {
  const selectId = id || useId();
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-256">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-257">
          {label}
        </label>}
      <div className="relative" data-id="element-258">
        <select id={selectId} className={`
            flex h-10 w-full appearance-none rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 
            focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
          `} {...props} data-id="element-259">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-260">
              {option.label}
            </option>)}
        </select>
        <ChevronDown className="absolute right-3 top-3 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-261" />
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-262">{error}</p>}
    </div>;
}